/**************************************************
 * Nombre:       PremioPlan
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import prem from '../../../Recursos/ic_premio.svg'
import {obtenerProximoPremio} from "../../../CodigoCliente/Puntos/obtenerProximoPremio";
import {todos} from "../../../Constantes";

const PremioPlan = ({items = [], puntos}) => {
    const [premio, setPremio] = useState({});


    useEffect(() => {
        setPremio(obtenerProximoPremio({items: todos, puntos: puntos}));
    }, [puntos]);
    return (
        <Grid
            container
            justifyContent={'flex-end'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff',}}
        >

            <Grid container size={{xs: 9, sm: 10, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-end'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                        <Typography sx={{fontSize: 10, fontWeight: 500}}>Próximo Premio</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                        <Typography sx={{fontSize: 14, fontWeight: 500}}>{premio.nombre}</Typography>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 3, sm: 2, md: 2}} sx={{justifyContent: 'flex-start', pl: 1}}>
                <img src={prem} width={'80%'} height={'auto'}/>
            </Grid>

        </Grid>
    )

}
export default PremioPlan